export interface ServiceItem {
  id: string;
  title: string;
  description: string;
  tags: string[];
}

const servicesData: ServiceItem[] = [
  {
    id: 'frontend',
    title: 'Frontend Development',
    description:
      'Building modern, responsive, and accessible web applications with a focus on performance and user experience.',
    tags: ['React', 'TypeScript', 'Next.js', 'CSS Modules', 'Accessibility'],
  },
  {
    id: 'backend',
    title: 'Backend Development',
    description:
      'Designing and building scalable REST and GraphQL APIs, microservices, and server-side systems that are reliable and maintainable.',
    tags: ['Node.js', 'Go', 'PostgreSQL', 'REST', 'GraphQL'],
  },
  {
    id: 'fullstack',
    title: 'Full-Stack Development',
    description:
      'End-to-end product development across the entire stack — from database schema design to polished UI delivery.',
    tags: ['React', 'Node.js', 'TypeScript', 'PostgreSQL', 'Redis'],
  },
  {
    id: 'devops',
    title: 'DevOps & CI/CD',
    description:
      'Automating build, test, and deployment pipelines to accelerate delivery and reduce manual toil. Emphasis on reliability, speed, and observability.',
    tags: ['GitHub Actions', 'GitLab CI', 'ArgoCD', 'Helm', 'Terraform'],
  },
  {
    id: 'infrastructure',
    title: 'Infrastructure',
    description:
      'Architecting and managing container-based infrastructure with Kubernetes and Docker, ensuring high availability, scalability, and security.',
    tags: ['Kubernetes', 'Docker', 'Helm', 'Prometheus', 'Grafana'],
  },
  {
    id: 'cloud',
    title: 'Cloud Hosting Setup',
    description:
      'Provisioning and configuring cloud environments from scratch — networking, IAM, storage, and compute — following security and cost best practices.',
    tags: ['AWS', 'GCP', 'Azure', 'Terraform', 'Networking'],
  },
];

export default servicesData;
